import React, { Component } from 'react';

class Cuotas extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        let props = this.props;
        let descripcionCuotas = "Permite cuotas";
        let check = undefined;
        let permiteCuotas = props.data.empresaDatos.Denominacion;

        check = props.data.empresaDatos.PermiteCuotas != undefined ? props.data.empresaDatos.PermiteCuotas : false
        descripcionCuotas = check == false ? "NO " + descripcionCuotas : "√ " + descripcionCuotas

        return (
            <div className="row">
                <div className="col-xs-12">
                    <label className="label-primary" htmlFor="chkCuotas">{descripcionCuotas}</label>
                </div>
            </div>
        );
    }
}

export default Cuotas;  